import { render, staticRenderFns } from "./CourseResource.vue?vue&type=template&id=4238c9f6&scoped=true&"
import script from "./CourseResource.vue?vue&type=script&lang=js&"
export * from "./CourseResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238c9f6",
  null
  
)

export default component.exports